import img1 from "./components/assets/zenodot.png";
import img2 from "./components/assets/erato.jpg";
import img3 from "./components/assets/arystofanes.jpg";
import img4 from "./components/assets/arystrach.png";
import img5 from "./components/assets/euklides.jpg";
import img6 from "./components/assets/3.jpg";
import img7 from "./components/assets/4.jpg";
import img8 from "./components/assets/5.jpg";
import img9 from "./components/assets/6.jpg";
import img10 from "./components/assets/7.jpg";
import img11 from "./components/assets/8.jpg";
import img12 from "./components/assets/9.jpg";
import img13 from "./components/assets/10.jpg";
import img14 from "./components/assets/11.jpg";
import img15 from "./components/assets/2.png";
import img16 from "./components/assets/12.jpg";
import img17 from "./components/assets/13.jpg";
import img18 from "./components/assets/14.jpg";
import img19 from "./components/assets/arystofanes.png";
import img20 from "./components/assets/15.jpg";
import img21 from "./components/assets/16.jpg";
import img22 from "./components/assets/3.png";
import img23 from "./components/assets/17.jpg";
import img24 from "./components/assets/18.jpg";
import img25 from "./components/assets/4.png";
import img26 from "./components/assets/19.jpg";
import img27 from "./components/assets/21.jpg";
import img28 from "./components/assets/1.jpg";
import img29 from "./components/assets/20.jpg";
import img30 from "./components/assets/22.jpg";

export const featuredPortfolio = [
  {
    id: 1,
    title: "ok. 325 – ok. 265 p.n.e.",
    img: img1,
  },
  {
    id: 2,
    title:
      "Uznawany za ojca filologii oraz autor pierwszego krytycznego wydania Iliady i Odysei Homera oraz Teogonii Hezjoda",
    img: img26,
  },
  {
    id: 3,
    title:
      "Pierwszy kier. Biblioteki Aleksandryjskiej, wychowawca Ptolemeusza II Filadelfosa",
    img: img27,
  },
  {
    id: 4,
    title:
      "Swe stanowisko łączył z obowiązkami wychowawcy następcy tronu, co odtąd miało być na dworze ptolemejskim regułą",
    img: img28,
  },
  {
    id: 5,
    title:
      "Ptolemeusz II - postanowił zgromadzić całe piśmiennictwo greckie dostępne za jego czasów",
    img: img29,
  },
  {
    id: 6,
    title:
      "W Musejonie wydzielił teksty z zakresu epiki i liryki, a jego pomocnicy zajęli się opracowaniem tragedii i komedii",
    img: img30,
  },
];

export const webPortfolio = [
  {
    id: 1,
    title: "ur. 276 p.n.e. w Cyrenie, zm. 194 p.n.e.",
    img: img2,
  },
  {
    id: 2,
    title:
      "Wyznaczył obwód Ziemi oraz oszacował odległość od Słońca i Księżyca do Ziemi",
    img: img21,
  },
  {
    id: 3,
    title:
      "Jako pierwszy zaproponował wprowadzenie roku przestępnego, czyli wydłużonego o jeden dodatkowy dzień w kalendarzu",
    img: img22,
  },
  {
    id: 4,
    title:
      "Najważniejsze dzieła Eratostenesa to: Geographica, Catasterismi, Peri komodias",
    img: img23,
  },
  {
    id: 5,
    title:
      "Geographica – trzytomowe dzieło zawierające podstawy geografii matematycznej i geografii fizycznej",
    img: img24,
  },
  {
    id: 6,
    title:
      "Catasterismi – dzieło astronomiczne, Peri komodias – rozprawa o dawnej komedii",
    img: img25,
  },
];

export const mobilePortfolio = [
  {
    id: 1,
    title: "ok. 257 – ok. 180 p.n.e.",
    img: img3,
  },
  {
    id: 2,
    title:
      "Do jego najważniejszych dzieł należą O kurtyzanach w Attyce oraz krytyczne wydania dzieł Homera",
    img: img16,
  },
  {
    id: 3,
    title: "Autor pierwszego dzieła leksykograficznego Lexeis",
    img: img17,
  },
  {
    id: 4,
    title: "Zwolennik analogii jako zasady rządzącej językiem",
    img: img18,
  },
  {
    id: 5,
    title: "Miał wprowadzić znaki akcentowe i interpunkcyjne",
    img: img19,
  },
  {
    id: 6,
    title: "Jako leksykograf zebrał zbiory archaicznych i niezwykłych słów ",
    img: img20,
  },
];

export const designPortfolio = [
  {
    id: 1,
    title: "ur. 216 p.n.e., zm. 144 p.n.e.",
    img: img4,
  },
  {
    id: 2,
    title: "Wyszło mu, że Słońce jest od nas 18 do 20 razy dalej niż Księżyc",
    img: img11,
  },
  {
    id: 3,
    title:
      "Zachowała się jedna tylko jego praca: O rozmiarach i odległościach Słońca i Księżyca",
    img: img12,
  },
  {
    id: 4,
    title:
      "W czasach Arystarcha, w pierwszej połowie III w.p.n.e., nauka przeniosła się do Aleksandrii",
    img: img13,
  },
  {
    id: 5,
    title: "Ziemia unoszona jest po kole wokół centralnie położonego Słońca",
    img: img14,
  },
  {
    id: 6,
    title: "Wedle jego hipotez gwiazdy stałe oraz Słońce są nieruchome",
    img: img15,
  },
];

export const contentPortfolio = [
  {
    id: 1,
    title: "ur. ok. 365 r. p.n.e., zm. ok. 270 r. p.n.e.",
    img: img5,
  },
  {
    id: 2,
    title: "Szkoła Euklidesa w Atenach",
    img: img6,
  },
  {
    id: 3,
    title: "Głównym dziełem Euklidesa są Elementy",
    img: img7,
  },
  {
    id: 4,
    title:
      "Było to aksjomatyczne ujęcie geometrii, które dotrwało w niezmienionej postaci jako kanon geometrii aż do XIX wieku",
    img: img8,
  },
  {
    id: 5,
    title: "Zachowało się dzieło Euklidesa z optyki",
    img: img9,
  },
  {
    id: 6,
    title:
      "Zajmował się też perspektywą, a mianowicie pozornym zmniejszaniem obrazu przy oddalaniu obiektu",
    img: img10,
  },
];
